import { Component, OnInit } from '@angular/core';
import { RolJuegosService } from 'src/app/services/roljuegos.service';
import { CompilacionService } from 'src/app/services/compilacion.service';

@Component({
  selector: 'app-estadisticas',
  templateUrl: './estadisticas.component.html',
  styleUrls: ['./estadisticas.component.css']
})
export class EstadisticasComponent implements OnInit {

  temporada = '';
  jornada = '';
  temporadaID = 0;

  Equipos: any[] = [];
  busqueda = '';
  resultados: any[] = [];
  equipoSel: any = null;
  infoEquipo: any = null;

  compilacionBateo: any[] = [];
  compilacionPitcheo: any[] = [];
  lideresBateo: any[] = [];
  lideresPitcheo: any[] = [];

  tab = 'bateo';
  pendientes = 0;

  constructor(
    private roljuegos_service: RolJuegosService,
    private compilacion_service: CompilacionService
  ) { }

  ngOnInit(): void {
    this.JornadaCompilacion();
  }

  get cargando(): boolean {
    return this.pendientes > 0;
  }

  JornadaCompilacion(): void {
    this.compilacion_service.obtenerJornadaCompilacion()
      .subscribe((object: any) => {
        if (object.ok && object.data.length > 0) {
          this.temporadaID = +object.data[0].TemporadaID;
          this.temporada = object.data[0].Temporada;
          this.jornada = object.data[0].Jornada;
          this.EquiposTemporada();
        }
      });
  }

  EquiposTemporada(): void {
    let json = {
      TemporadaID: this.temporadaID,
    };
    this.Equipos = [];
    this.roljuegos_service.equiposTemporada(json)
      .subscribe((object: any) => {
        if (object.ok) {
          this.Equipos = object.data;
        }
      });
  }

  buscarEquipo(): void {
    const texto = this.busqueda.trim().toUpperCase();
    if (!texto) {
      this.resultados = [];
      return;
    }
    this.resultados = this.Equipos
      .filter((equipo: any) => String(equipo.Equipo).toUpperCase().includes(texto))
      .slice(0, 12);
  }

  EquipoSeleccionado(equipo: any): void {
    this.equipoSel = equipo;
    this.infoEquipo = null;
    this.busqueda = '';
    this.resultados = [];
    this.tab = 'bateo';
    this.buscarBateo(+equipo.InscripcionID);
    this.buscarPitcheo(+equipo.InscripcionID);
  }

  cambiarEquipo(): void {
    this.equipoSel = null;
    this.infoEquipo = null;
    this.compilacionBateo = [];
    this.compilacionPitcheo = [];
    this.lideresBateo = [];
    this.lideresPitcheo = [];
  }

  buscarBateo(busInscripcionID: number): void {
    let json = {
      InscripcionID: busInscripcionID
    };
    this.compilacionBateo = [];
    this.pendientes++;
    this.compilacion_service.obtenerBateo(json)
      .subscribe((object: any) => {
        this.pendientes--;
        if (object.ok) {
          this.compilacionBateo = this.ordenarPor(object.data || [], 'PCT');
          if (this.compilacionBateo.length > 0) {
            const primero = this.compilacionBateo[0];
            this.infoEquipo = {
              nombre: primero.Equipo,
              detalle: primero.Categoria + ' · Clasificación ' + primero.Clasificacion + ' · Grupo ' + primero.Grupo
            };
          }
          this.calcularLideresBateo();
        }
      }, () => { this.pendientes--; });
  }

  buscarPitcheo(busInscripcionID: number): void {
    let json = {
      InscripcionID: busInscripcionID
    };
    this.compilacionPitcheo = [];
    this.pendientes++;
    this.compilacion_service.obtenerPitcheo(json)
      .subscribe((object: any) => {
        this.pendientes--;
        if (object.ok) {
          this.compilacionPitcheo = this.ordenarPor(object.data || [], 'Ganados');
          this.calcularLideresPitcheo();
        }
      }, () => { this.pendientes--; });
  }

  private calcularLideresBateo(): void {
    this.lideresBateo = [];
    if (this.compilacionBateo.length === 0) { return; }
    const mejorPct = this.lider(this.compilacionBateo, 'PCT');
    const masHits = this.lider(this.compilacionBateo, 'TH');
    const masHr = this.lider(this.compilacionBateo, 'HR');
    const masProducidas = this.lider(this.compilacionBateo, 'CE');
    this.lideresBateo = [
      { etiqueta: 'Mejor PCT', valor: mejorPct.PCT, jugador: mejorPct.Jugador },
      { etiqueta: 'Más hits', valor: masHits.TH, jugador: masHits.Jugador },
      { etiqueta: 'Más home runs', valor: masHr.HR, jugador: masHr.Jugador },
      { etiqueta: 'Más producidas', valor: masProducidas.CE, jugador: masProducidas.Jugador }
    ];
  }

  private calcularLideresPitcheo(): void {
    this.lideresPitcheo = [];
    if (this.compilacionPitcheo.length === 0) { return; }
    const masGanados = this.lider(this.compilacionPitcheo, 'Ganados');
    const masPonches = this.lider(this.compilacionPitcheo, 'K');
    const masInnings = this.lider(this.compilacionPitcheo, 'IP');
    const conInnings = this.compilacionPitcheo.filter((pitcheo: any) => this.aNumero(pitcheo.IP) > 0);
    const mejorPcl = conInnings.length > 0 ? this.lider(conInnings, 'PCL', 'asc') : null;
    this.lideresPitcheo = [
      { etiqueta: 'Más ganados', valor: masGanados.Ganados, jugador: masGanados.Jugador },
      { etiqueta: 'Más ponches', valor: masPonches.K, jugador: masPonches.Jugador },
      { etiqueta: 'Mejor PCL', valor: mejorPcl ? mejorPcl.PCL : '-', jugador: mejorPcl ? mejorPcl.Jugador : '-' },
      { etiqueta: 'Más innings', valor: masInnings.IP, jugador: masInnings.Jugador }
    ];
  }

  private lider(lista: any[], campo: string, orden: string = 'desc'): any {
    return this.ordenarPor(lista, campo, orden)[0];
  }

  private ordenarPor(lista: any[], campo: string, orden: string = 'desc'): any[] {
    const copia = lista.slice();
    copia.sort((a: any, b: any) => {
      const valorA = this.aNumero(a[campo]);
      const valorB = this.aNumero(b[campo]);
      return orden === 'desc' ? valorB - valorA : valorA - valorB;
    });
    return copia;
  }

  aNumero(valor: any): number {
    const numero = parseFloat(String(valor).replace(',', '.'));
    return isNaN(numero) ? 0 : numero;
  }
}
